import { render, staticRenderFns } from "./ConnectThePuzzlesForm.vue?vue&type=template&id=3a6d6b85&scoped=true&lang=pug&"
import script from "./ConnectThePuzzlesForm.vue?vue&type=script&lang=js&"
export * from "./ConnectThePuzzlesForm.vue?vue&type=script&lang=js&"
import style0 from "./ConnectThePuzzlesForm.vue?vue&type=style&index=0&id=3a6d6b85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6d6b85",
  null
  
)

export default component.exports